<!-- control de un valor: editable (texto, lista o Sí/No) o solo lectura -->
<ng-template #control let-field>
  @if (field.editable) { @switch (field.control) { @case ('select') {
  <select
    class="w-full rounded border px-2 py-1 text-sm"
    [ngClass]="changes[field.oid] !== undefined ? 'border-blue-400 bg-blue-50' : 'border-gray-300'"
    [ngModel]="valueOf(field)"
    (ngModelChange)="change(field, $event)"
    [attr.aria-label]="field.label"
  >
    @for (option of field.options; track option.value) {
    <option [value]="option.value">{{ optionLabel(option.label) }}</option>
    }
  </select>
  } @case ('radio') {
  <div
    class="inline-flex overflow-hidden rounded border text-xs font-semibold"
    [ngClass]="changes[field.oid] !== undefined ? 'border-blue-400' : 'border-gray-300'"
  >
    @for (option of field.options; track option.value) {
    <button
      type="button"
      class="px-3 py-1"
      [ngClass]="valueOf(field) === option.value ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'"
      (click)="change(field, option.value)"
    >
      {{ optionLabel(option.label) }}
    </button>
    }
  </div>
  } @default {
  <div class="relative">
    <input
      [type]="field.secret && !revealed.has(field.oid) ? 'password' : 'text'"
      class="w-full rounded border px-2 py-1 text-sm"
      [ngClass]="
        invalid[field.oid]
          ? 'border-red-400 bg-red-50'
          : changes[field.oid] !== undefined
            ? 'border-blue-400 bg-blue-50'
            : 'border-gray-300'
      "
      [class.pr-8]="field.secret"
      [ngModel]="valueOf(field)"
      (ngModelChange)="change(field, $event)"
      [attr.aria-label]="field.label"
      [placeholder]="field.secret && !field.value ? 'El equipo no la informa: escriba una para cambiarla' : ''"
      autocomplete="off"
    />
    @if (field.secret) {
    <button
      type="button"
      class="absolute inset-y-0 right-0 px-2 text-gray-400 hover:text-gray-700"
      [title]="revealed.has(field.oid) ? 'Ocultar' : 'Ver contraseña'"
      (click)="toggleReveal(field.oid)"
    >
      <i class="pi text-xs" [ngClass]="revealed.has(field.oid) ? 'pi-eye-slash' : 'pi-eye'"></i>
    </button>
    }
  </div>
  } } @if (invalid[field.oid]) {
  <p class="mt-1 text-xs text-red-600">{{ invalid[field.oid] }}</p>
  } } @else if (field.secret) {
  <span class="font-mono text-gray-700"
    >{{ revealed.has(field.oid) ? display(field) : '••••••••' }}</span
  >
  <button
    type="button"
    class="ml-2 text-xs text-blue-700 hover:underline"
    (click)="toggleReveal(field.oid)"
  >
    {{ revealed.has(field.oid) ? 'Ocultar' : 'Ver' }}
  </button>
  } @else {
  <span class="text-gray-800 [overflow-wrap:anywhere]">{{ display(field) }}</span>
  } @if (field.hint) {
  <p class="mt-1 text-xs text-gray-500">{{ field.hint }}</p>
  } @if (field.associatedOid) {
  <button
    type="button"
    class="ml-2 inline-flex items-center gap-1 text-xs text-blue-700 hover:underline"
    (click)="toggleDevices(field.associatedOid)"
  >
    <i class="pi pi-users text-[11px]"></i>
    {{ devices[field.associatedOid] && devices[field.associatedOid] !== 'error' ? 'Ocultar equipos'
    : 'Ver equipos conectados' }}
  </button>
  @if (devices[field.associatedOid] === 'loading') {
  <div class="mt-2 h-16 animate-pulse rounded bg-gray-100"></div>
  } @else if (devices[field.associatedOid] === 'error') {
  <p class="mt-1 text-xs text-red-600">No se pudieron leer los equipos conectados.</p>
  } @if (devicesOf(field.associatedOid); as list) {
  <table class="mt-2 text-xs" aria-describedby="Equipos conectados al WiFi">
    <thead class="text-left text-gray-600">
      <tr>
        @for (column of list.columns; track $index) {
        <th class="border-b px-2 py-1 font-semibold">{{ column }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of list.rows; track $index) {
      <tr class="odd:bg-gray-50">
        @for (cell of row; track $index) {
        <td class="font-mono px-2 py-1">{{ optionLabel(cell) }}</td>
        }
      </tr>
      } @empty {
      <tr>
        <td class="px-2 py-1 text-gray-500" [attr.colspan]="list.columns.length || 1">
          Ningún equipo conectado.
        </td>
      </tr>
      }
    </tbody>
  </table>
  } }
</ng-template>

@if (!enabled) {
<!-- como SmartOLT: el botón solo explica cómo activarlo -->
<div
  class="flex items-start gap-3 rounded-lg border border-sky-200 bg-sky-50 p-4 text-sm text-sky-900"
>
  <i class="pi pi-info-circle mt-0.5 text-sky-600"></i>
  <div>
    <p class="font-semibold">TR-069 no está habilitado en esta ONU.</p>
    <p class="mt-1">
      Actívelo desde <strong>Perfil TR069</strong> (Mgmt IP) en la pestaña Servicio para ver y
      configurar el WiFi y los puertos LAN del equipo.
    </p>
  </div>
</div>
} @else if (loading && !status) {
<!-- esqueleto con la forma de los grupos -->
<div class="flex animate-pulse flex-col gap-2">
  @for (w of [40, 28, 36, 32, 30]; track $index) {
  <div class="flex items-center gap-3 rounded-lg border border-gray-200 px-4 py-3">
    <span class="h-4 w-4 rounded bg-gray-200"></span>
    <span class="h-3.5 rounded bg-gray-200" [style.width.%]="w"></span>
    <span class="ml-auto h-3.5 w-6 rounded bg-gray-100"></span>
  </div>
  }
</div>
} @else if (error) {
<div class="flex items-center justify-between rounded bg-red-50 p-3 text-sm text-red-700">
  {{ error }}
  <button type="button" class="font-semibold underline" (click)="load()">Reintentar</button>
</div>
} @else if (status) {
<div class="flex flex-col gap-2 text-sm">
  @if (status.delay60 && status.message) {
  <p class="rounded bg-amber-50 p-2 text-xs text-amber-800">
    <i class="pi pi-clock mr-1"></i>{{ status.message }}
  </p>
  }

  <div class="flex items-center justify-between">
    <p class="text-xs text-gray-500">
      Datos que el equipo informó al ACS. Use <i class="pi pi-refresh text-[10px]"></i> en cada
      grupo para pedirlos de nuevo.
    </p>
    <p-button
      label="Recargar todo"
      icon="pi pi-refresh"
      size="small"
      severity="secondary"
      [outlined]="true"
      [loading]="loading"
      (onClick)="load()"
    />
  </div>

  @if (!status.groups.length) {
  <!-- el equipo todavía no informó al ACS: SmartOLT solo manda un aviso -->
  <div
    class="flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 p-4 text-amber-900"
  >
    <i class="pi pi-exclamation-triangle mt-0.5 text-amber-600"></i>
    <div>
      <p class="font-semibold">El equipo no ha enviado datos al servidor TR-069.</p>
      @if (status.message && !status.delay60) {
      <p class="mt-1 text-xs">{{ status.message }}</p>
      }
      <p class="mt-1 text-xs">
        Verifique que la ONU tenga IP de gestión y conexión con el ACS, y vuelva a cargar.
      </p>
    </div>
  </div>
  } @for (group of status.groups; track group.name) {
  <section class="overflow-hidden rounded-lg border border-gray-200 bg-white">
    <div class="flex items-center gap-2 bg-gray-50 px-4 py-2.5">
      <button
        type="button"
        class="flex flex-1 items-center gap-2 text-left font-semibold text-gray-800"
        [attr.aria-expanded]="open.has(group.name)"
        (click)="toggle(group.name)"
      >
        <i class="pi text-sky-700" [ngClass]="groupIcon(group)"></i>
        {{ groupName(group.name) }} @if (changedIn(group); as n) {
        <span class="rounded-full bg-blue-100 px-2 text-xs font-semibold text-blue-700">
          {{ n }} sin aplicar
        </span>
        }
      </button>
      <button
        type="button"
        class="rounded p-1 text-gray-500 hover:bg-gray-200 hover:text-gray-800"
        title="Pedir los valores de nuevo al equipo"
        [disabled]="refreshing.has(group.name)"
        (click)="refreshGroup(group.name)"
      >
        <i class="pi pi-refresh text-xs" [class.pi-spin]="refreshing.has(group.name)"></i>
      </button>
      <i
        class="pi text-xs text-gray-400"
        [ngClass]="open.has(group.name) ? 'pi-chevron-up' : 'pi-chevron-down'"
      ></i>
    </div>

    @if (open.has(group.name)) {
    <div class="px-4 py-3">
      @if (group.empty) {
      <p class="text-gray-500">
        {{ group.empty === 'No records found' ? 'Sin registros.' : group.empty }}
      </p>
      } @else if (group.layout === 'table') {
      <div class="overflow-x-auto">
        <table class="min-w-full text-xs md:text-sm" [attr.aria-describedby]="group.name">
          <thead class="border-b-2 border-sky-300 text-left text-gray-700">
            <tr>
              @for (column of group.columns; track $index) {
              <th class="whitespace-nowrap px-2 py-1.5 font-semibold">{{ column }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of group.rows; track $index) {
            <tr class="border-b border-gray-100 align-top">
              @for (field of row; track $index) {
              <td class="px-2 py-1.5" [class.min-w-[120px]]="field.editable">
                <ng-container
                  [ngTemplateOutlet]="control"
                  [ngTemplateOutletContext]="{ $implicit: field }"
                />
              </td>
              }
            </tr>
            }
          </tbody>
        </table>
      </div>
      } @else {
      <dl class="grid grid-cols-1 gap-x-6 gap-y-2 md:grid-cols-[minmax(160px,220px)_1fr]">
        @for (field of group.fields; track $index) {
        <dt class="pt-1 text-xs font-semibold uppercase tracking-wide text-gray-500">
          {{ field.label }}
        </dt>
        <dd class="max-w-xl">
          <ng-container
            [ngTemplateOutlet]="control"
            [ngTemplateOutletContext]="{ $implicit: field }"
          />
        </dd>
        }
      </dl>
      }
    </div>
    }
  </section>
  }

  <!-- barra de cambios sin aplicar -->
  @if (changeCount) {
  <div
    class="sticky bottom-0 flex flex-wrap items-center gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-2.5 shadow"
  >
    <span class="font-semibold text-blue-900">{{ changeCount }} cambio(s) sin aplicar</span>
    <label class="flex items-center gap-1.5 text-xs text-blue-900">
      <input type="checkbox" [(ngModel)]="rememberWifi" />
      Recordar el WiFi en SmartOLT (para reprovisionar tras un reset de fábrica)
    </label>
    <span class="ml-auto flex gap-2">
      <p-button
        label="Descartar"
        size="small"
        severity="secondary"
        [text]="true"
        (onClick)="discard()"
      />
      <p-button
        [label]="changeCount === 1 ? 'Aplicar 1 cambio' : 'Aplicar ' + changeCount + ' cambios'"
        icon="pi pi-check"
        size="small"
        [loading]="saving"
        [disabled]="hasInvalid"
        (onClick)="apply()"
      />
    </span>
  </div>
  }
</div>
}
